import { COMPANY, personUrl } from "@/data/founders";

export const buildVcard = (f) => {
  const whatsappTel = `+${f.whatsapp}`;
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${f.lastName};${f.firstName};;${f.prefix};`,
    `FN:${f.name}`,
    `ORG:${COMPANY}`,
    `TITLE:${f.designation}`,
    `TEL;TYPE=CELL,VOICE:${f.phone}`,
  ];
  if (whatsappTel !== f.phone) {
    lines.push(`TEL;TYPE=WORK,MSG:${whatsappTel}`);
  }
  lines.push(
    `EMAIL;TYPE=WORK:${f.email}`,
    "ADR;TYPE=WORK:;;Ahmedabad;Gujarat;;;India",
    `URL:${personUrl(f.slug)}`,
    `IMPP;X-SERVICE-TYPE=WhatsApp:https://wa.me/${f.whatsapp}`,
    "END:VCARD",
  );
  return lines.join("\r\n");
};

export const downloadVcard = (f) => {
  const blob = new Blob([buildVcard(f)], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${f.slug}-ascend.vcf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
